import React from 'react';
import Support from "./Support";
import LiveChat from "./LiveChat";
import Cards from "./Cards";
import Call from "./Call";
import styles from "./styles.module.scss";
import ContactForm from "./ContactForm";
import CustomerSupportHero from "./CustomerSupportHero";
import useTranslation from "next-translate/useTranslation";
import {CUSTOMER_SUPPORT_NAMESPACE} from "../../../utils/i18nNameSpaces";
import {GROUP_PHONE, SUPPORT_GROUP} from "../../../utils/constants";

const Index = () => {
  const {t} = useTranslation(CUSTOMER_SUPPORT_NAMESPACE);
  return (
    <div className={styles["main"]}>
      <CustomerSupportHero t={t}/>
      <Support t={t}/>
      <LiveChat t={t}/>
      <Cards t={t}/>
      <Call t={t}/>
      <ContactForm contactT={t} email={SUPPORT_GROUP} phone={GROUP_PHONE}/>
    </div>
  );
};

export default Index;